@import '~less/global-variables';
.circle-location-map-panel {
  background: #fff;
  color: #333;
  text-shadow: none;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 6px 28px rgba(0, 0, 0, 0.12);
}
.circle-location-map-heading h3 {
  margin: 0 0 4px;
}
.circle-location-map-heading p,
.circle-location-map-footer {
  margin: 4px 0 0;
  font-size: 13px;
}
.circle-location-map-heading {
  margin-bottom: 12px;
}
.circle-location-map-footer {
  color: @gray;
  line-height: 1.6;
}
.circle-location-popup {
  min-width: 200px;
  max-width: 300px;
  line-height: 1.5;
  strong {
    font-size: 15px;
  }
  dl {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 4px 14px;
    margin: 10px 0;
  }
  dt {
    color: @gray;
    font-weight: normal;
  }
  dd {
    margin: 0;
  }
  p {
    margin: 6px 0;
    font-size: 12px;
    color: @gray;
  }
  a {
    overflow-wrap: anywhere;
  }
}
.circle-location-map {
  width: 100%;
  height: clamp(300px, 42vh, 440px);
  min-height: 300px;
  border-radius: 8px;
  background: #e8eeea;
  z-index: 0;
}
.circle-location-map-frame {
  position: relative;
}
@media (max-width: @screen-sm-min) {
  .circle-location-map {
    height: 48vh;
    min-height: 300px;
  }
}

.tribe-header .circle-location-map-panel a:not(.btn) {
  &,
  &:visited {
    color: @link-color;
  }
  &:hover,
  &:focus,
  &:active {
    color: @link-hover-color;
  }
  &:focus-visible {
    outline: 2px solid @link-color;
    outline-offset: 2px;
  }
}
.tribe-header .circle-location-map-panel a.leaflet-popup-close-button {
  width: 32px;
  height: 32px;
  top: 5px;
  right: 5px;
  padding: 0;
  border-radius: 50%;
  font:
    24px/32px Arial,
    sans-serif;
  text-align: center;
  text-decoration: none;
  &:hover,
  &:focus {
    background: #edf6f2;
    text-decoration: none;
  }
}
.circle-location-map .leaflet-popup-content {
  margin-right: 38px;
}

.circle-location-map-panel--brand {
  border: 1px solid fade(@brand-primary, 25%);
  border-top: 4px solid @brand-primary;
  box-shadow: 0 6px 28px fade(darken(@brand-primary, 30%), 18%);

  h3,
  .leaflet-popup-content strong {
    color: darken(@brand-primary, 18%);
  }

  .circle-location-map {
    background: lighten(@brand-primary, 52%);
  }

  a:not(.btn) {
    &,
    &:hover,
    &:focus,
    &:active {
      color: darken(@brand-primary, 15%);
      text-shadow: none;
    }
  }

  .leaflet-popup-content-wrapper {
    border-top: 3px solid @brand-primary;
    border-radius: 12px;
  }
}
